
<template>

  <footer class="vlastFooter">
    <div class="container">
      <div class="footer-social" v-if="!$whitelabel">
        <vlast-logo-monogram class="footer-logo" :fill="'white'"/>
        <h2>Unleash your star power!</h2>
      </div>

      <div class="footer-bottom vlast-footer-bottom">
        <div class="row">
          <div class="col-lg-10">
            <p class="phone">
              <i class="fa fa-phone"></i>
              <a :href="getPhone(vlastContactNumber)" v-if="$userIsAdmin">{{ vlastContactNumber }}</a>
              <a :href="getPhone(contactNumber)" v-else>{{ contactNumber }}</a>
            </p>
          </div>
          <div class="col-lg-2">
            <p class="right">Copyright Pickstar &copy; {{ year }}</p>
          </div>
        </div>
        <div class="marketplaceFooter_main_section">
          <p class="marketplaceFooter_generalNav phone" >
            <a v-if="privacy_link" :href="privacy_link" target="_blank">Privacy Policy</a>
            <a v-if="tnc_link" :href="tnc_link" target="_blank">Terms and Conditions</a>
            <a href="https://govlast.com/policies/privacy" target="_blank">Vlast Privacy Policy</a>
          </p>
        </div>
      </div>

    </div>
  </footer>

</template>

<script>
import VlastLogoMonogram from '../icons/VlastLogoMonogram'
import { http } from 'utils'

export default {
  components: {
    VlastLogoMonogram
  },

  data () {
    return {
      tnc_link: null,
      privacy_link: null
    }
  },

  mounted () {
    this.getLinks().then(response => {
      this.tnc_link = response.data.tnc_link
      this.privacy_link = response.data.privacy_link
    })
  },

  computed: {
    year () {
      const date = new Date()
      return date.getFullYear()
    }
  },

  methods: {
    getPhone (contactNumber) {
      return `tel:${contactNumber}`
    },
    getLinks () {
      return http.get('public_settings')
    }
  }
}
</script>
